export const formatPhoneForSendApi = phone => {
  return `+55${phone.replace(/[^\d]+/g, "")}`
}

export default formatPhoneForSendApi
